import { Utils } from '@client/utility';

export interface Transaction {
  id: string;
  amount: number;
  type: string;
  tokens_used: number;
  created_at: string;
  char_uuid?: string;
}

export interface CreditPurchase {
  id: string;
  user_uuid: string;
  credits_purchased: number;
  created_at: string;
}

export interface BalanceResponse {
  status: string;
  balance: number;
}

export const fetchBalanceAPI = async (userUUID: string): Promise<number> => {
  const res = await Utils.post<BalanceResponse>('/webhook/balance', {
    user_uuid: userUUID
  });

  if (res.status !== 'success') {
    throw new Error('Failed to load balance');
  }

  return res.balance;
};

export const fetchTransactionsAPI = async (userUUID: string): Promise<Transaction[]> => {
  const { data: txData } = await Utils.db.select({
    tables: 'transactions',
    columns: 'id, amount, type, tokens_used, created_at, char_uuid',
    match: { user_uuid: userUUID },
    orderBy: { column: 'created_at', ascending: false },
  });

  const { data: purchaseData } = await Utils.db.select({
    tables: 'credit_purchases',
    columns: 'id, user_uuid, credits_purchased, created_at',
    match: { user_uuid: userUUID },
    orderBy: { column: 'created_at', ascending: false },
  });

  const transactions: Transaction[] = (txData as Transaction[]) || [];
  const purchases: CreditPurchase[] = (purchaseData as CreditPurchase[]) || [];

  const mappedPurchases: Transaction[] = purchases.map(p => ({
    id: p.id,
    amount: p.credits_purchased,
    type: 'purchase',
    tokens_used: 0,
    created_at: p.created_at,
    char_uuid: undefined
  }));

  const combined = [...transactions, ...mappedPurchases].sort(
    (a, b) => new Date(b.created_at).getTime() - new Date(a.created_at).getTime()
  );

  return combined;
};